import { MESES_ORDEM, obterMesAbreviado } from './formatters.js';

/**
 * Processa os dados retornados da API e extrai os valores necessários
 * para os cards de Faturamento e Lucro.
 *
 * @param {Object} resposta - Resposta da API com os dados da visão geral
 * @returns {Object} Objeto com dados de faturamento e lucro
 */
export const processarDadosVisaoGeral = (resposta) => {
  /**
   * FATURAMENTO
   */
  const dadosFaturamentoTodos = [
    ...(resposta.visao_geral_faturamento || []),
    ...(resposta.visao_geral_fat_projecao || []),
  ];

  let faturamentoValorTotal = null;
  let faturamentoPercentual = null;
  let faturamentoProjecao = null;

  dadosFaturamentoTodos.forEach((item) => {
    if (!faturamentoValorTotal) {
      faturamentoValorTotal =
        item['visao_geral.valor_total'] ?? item.valor_total ?? null;
    }

    if (!faturamentoPercentual) {
      faturamentoPercentual =
        item['visao_geral.percentual_crescimento_mes_faturamento'] ??
        item.percentual_crescimento_mes_faturamento ??
        null;
    }

    if (!faturamentoProjecao) {
      faturamentoProjecao =
        item['visao_geral.calculo_projecao_faturamento'] ??
        item.calculo_projecao_faturamento ??
        null;
    }
  });

  // Fallbacks individuais
  if (!faturamentoValorTotal && resposta.visao_geral_faturamento?.[0]) {
    const item = resposta.visao_geral_faturamento[0];
    faturamentoValorTotal =
      item['visao_geral.valor_total'] ?? item.valor_total ?? null;
  }


  if (!faturamentoProjecao && resposta.visao_geral_fat_projecao?.[0]) {
    const item = resposta.visao_geral_fat_projecao[0];
    faturamentoProjecao =
      item['visao_geral.calculo_projecao_faturamento'] ??
      item.calculo_projecao_faturamento ??
      null;
  }

  /**
   * LUCRO
   */
  const dadosLucroTodos = [
    ...(resposta.visao_geral_lucro || []),
    ...(resposta.visao_geral_lucro_projecao || []),
    ...(resposta.visao_geral_margem_lucro || []),
  ];

  let lucroValorTotal = null;
  let lucroPercentual = null;
  let lucroProjecao = null;
  let margemLucro = null;

  dadosLucroTodos.forEach((item) => {
    if (!lucroValorTotal) {
      lucroValorTotal =
        item['visao_geral.lucro_total'] ?? item.lucro_total ?? null;
    }

    if (!lucroPercentual) {
      lucroPercentual =
        item['visao_geral.lucro_percentual_crescimento_mes'] ??
        item.lucro_percentual_crescimento_mes ??
        null;
    }

    if (!lucroProjecao) {
      lucroProjecao =
        item['visao_geral.calculo_projecao_lucro'] ??
        item.calculo_projecao_lucro ??
        null;
    }

    if (!margemLucro) {
      margemLucro =
        item['visao_geral.margem_lucro'] ?? item.margem_lucro ?? null;
    }
  });

  // Fallbacks individuais lucro
  if (!lucroValorTotal && resposta.visao_geral_lucro?.[0]) {
    const item = resposta.visao_geral_lucro[0];
    lucroValorTotal =
      item['visao_geral.lucro_total'] ?? item.lucro_total ?? null;
  }


  if (!lucroProjecao && resposta.visao_geral_lucro_projecao?.[0]) {
    const item = resposta.visao_geral_lucro_projecao[0];
    lucroProjecao =
      item['visao_geral.calculo_projecao_lucro'] ??
      item.calculo_projecao_lucro ??
      null;
  }

  if (!margemLucro && resposta.visao_geral_margem_lucro?.[0]) {
    const item = resposta.visao_geral_margem_lucro[0];
    margemLucro =
      item['visao_geral.margem_lucro'] ?? item.margem_lucro ?? null;
  }

  /**
   * Custo
   */
  const dadosCustoTodos = [
    ...(resposta.visao_geral_custo || []),
    ...(resposta.visao_geral_custo_projecao || []),
  ];

  let custoValorTotal = null;
  let custoPorcentagem = null;
  let custoProjecao = null;

  dadosCustoTodos.forEach((item) => {
    if (!custoValorTotal) {
      custoValorTotal =
        item['visao_geral.total_custo'] ?? item.total_custo ?? null;
    }

    if (!custoPorcentagem) {
      custoPorcentagem =
        item['visao_geral.percentual_crescimento_mes_custo'] ??
        item.percentual_crescimento_mes_custo ??
        null;
    }

    if (!custoProjecao) {
      custoProjecao =
        item['visao_geral.calculo_projecao_custo'] ??
        item.calculo_projecao_custo ??
        null;
    }
  });

  // Fallbacks individuais
  if (!custoValorTotal && resposta.visao_geral_custo?.[0]) {
    const item = resposta.visao_geral_custo[0];
    custoValorTotal =
      item['visao_geral.total_custo'] ?? 
      item.total_custo ?? 
      null;
  }


  if (!custoProjecao && resposta.visao_geral_custo_projecao?.[0]) {
    const item = resposta.visao_geral_custo_projecao[0];
    custoProjecao =
      item['visao_geral.calculo_projecao_custo'] ??
      item.calculo_projecao_custo ??
      null;
  }

  /**
   * Litros
   */
  const dadosLitrosTodos = [
    ...(resposta.visao_geral_litros || []),
    ...(resposta.visao_geral_litros_projecao || []),
  ];

  let litrosValorTotal = null;
  let litrosProjecao = null;

  dadosLitrosTodos.forEach((item) => {
    if (!litrosValorTotal) {
      litrosValorTotal =
        item['visao_geral.quantidade'] ?? item.litros_total ?? null;
    }

    if (!litrosProjecao) {
      litrosProjecao =
        item['visao_geral.calculo_projecao_litros'] ??
        item.calculo_projecao_litros ??
        null;
    }
  });

  if (!litrosValorTotal && resposta.visao_geral_litros?.[0]) {
    const item = resposta.visao_geral_litros[0];
    litrosValorTotal =
      item['visao_geral.quantidade'] ?? item.litros_total ?? null;
  }

  if (!litrosProjecao && resposta.visao_geral_litros_projecao?.[0]) {
    const item = resposta.visao_geral_litros_projecao[0];
    litrosProjecao =
      item['visao_geral.calculo_projecao_litros'] ??
      item.calculo_projecao_litros ??
      null;
  }

  // Processar visao_geral_litros_volume - pegar o primeiro registro
  let litrosVolumeProduto = null;
  let litrosVolumePercentual = null;

  if (resposta.visao_geral_litros_volume?.[0]) {
    const primeiroRegistro = resposta.visao_geral_litros_volume[0];
    litrosVolumeProduto =
      primeiroRegistro['visao_geral.nome_produto'] ??
      primeiroRegistro.nome_produto ??
      null;
    litrosVolumePercentual =
      primeiroRegistro['visao_geral.quantidade_percentual'] ??
      primeiroRegistro.quantidade_percentual ??
      null;
  }
  /**
   * Abastecimento
   */
  const dadosAbastecimentoTodos = [
    ...(resposta.visao_geral_abastecimento || []),
    ...(resposta.visao_geral_abastecimento_projecao || []),
  ];

  let abastecimentoValorTotal = null;
  let abastecimentoPercentual = null;
  let abastecimentoProjecao = null;

  dadosAbastecimentoTodos.forEach((item) => {
    if (!abastecimentoValorTotal) {
      abastecimentoValorTotal =
        item['visao_geral.count_linhas'] ?? item.valor_total ?? null;
    }

    if (!abastecimentoPercentual) {
      abastecimentoPercentual =
        item['visao_geral.calculo_projecao_abastecimento'] ??
        item.percentual_crescimento_mes_abastecimento ??
        null;
    }

    if (!abastecimentoProjecao) {
      abastecimentoProjecao =
        item['visao_geral.calculo_projecao_abastecimento'] ??
        item.calculo_projecao_abastecimento ??
        null;
    }
  });

  if (!abastecimentoValorTotal && resposta.visao_geral_abastecimento?.[0]) {
    const item = resposta.visao_geral_abastecimento[0];
    abastecimentoValorTotal =
      item['visao_geral.valor_total'] ?? item.valor_total ?? null;
  }


  if (!abastecimentoProjecao && resposta.visao_geral_abastecimento_projecao?.[0]) {
    const item = resposta.visao_geral_abastecimento_projecao[0];
    abastecimentoProjecao =
      item['visao_geral.calculo_projecao_abastecimento'] ??
      item.calculo_projecao_abastecimento ??
      null;
  }

  let picoAbastecimento = null;
  let picoAbastecimentoPercentual = null;
  if (resposta.visao_geral_pico_abastecimento?.[0]) {
    const primeiroRegistro = resposta.visao_geral_pico_abastecimento[0];
    picoAbastecimento =
      primeiroRegistro['visao_geral.turno'] ?? primeiroRegistro.turno ?? null;
    picoAbastecimentoPercentual =
      primeiroRegistro['visao_geral.Abastecimentos_linhas_percentual'] ?? primeiroRegistro.percentual ?? null;
  }

  /**
   * Postos
   */
  let postosTotal = null;
  let postosAcimaMedia = 0;
  let mediaLucroPorPosto = null;
  let ticketMedioPorPosto = null;

  // Obter total de postos
  if (resposta.visao_geral_postos?.[0]) {
    const item = resposta.visao_geral_postos[0];
    postosTotal =
      item['visao_geral.diferentes_postos'] ??
      item.diferentes_postos ??
      null;
  }

  // Comparar lucro_postos com media_lucro_postos para contar quantos estão acima da média
  const lucroPostos = resposta.visao_geral_lucro_postos || [];
  const mediaLucroPostos = resposta.visao_geral_media_lucro_postos?.[0];

  if (mediaLucroPostos) {
    // Obter a média de lucro
    const mediaLucro =
      mediaLucroPostos['visao_geral.media_lucro_postos'] ??
      mediaLucroPostos.media_lucro_postos ??
      Object.values(mediaLucroPostos).find(val => typeof val === 'number' || (typeof val === 'string' && !isNaN(val)));

    if (mediaLucro !== null && mediaLucro !== undefined) {
      const mediaLucroNum = Number(mediaLucro);
      mediaLucroPorPosto = !isNaN(mediaLucroNum) ? mediaLucroNum : null;
      
      if (lucroPostos.length > 0) {
        // Contar quantos postos têm lucro maior que a média
        postosAcimaMedia = lucroPostos.filter((item) => {
          // Tentar diferentes campos possíveis para o lucro do posto
          const lucroPosto =
            item['visao_geral.lucro_postos'] ??
            item['visao_geral.lucro'] ??
            item.lucro_postos ??
            item.lucro ??
            Object.values(item).find(val => typeof val === 'number' || (typeof val === 'string' && !isNaN(val)));
          
          if (lucroPosto === null || lucroPosto === undefined) return false;
          
          const lucroPostoNum = Number(lucroPosto);
          return !isNaN(lucroPostoNum) && !isNaN(mediaLucroNum) && lucroPostoNum > mediaLucroNum;
        }).length;
      }
    }
  }

  // Calcular ticket médio por posto (faturamento total / número de postos)
  if (faturamentoValorTotal !== null && postosTotal !== null && postosTotal > 0) {
    const faturamentoNum = Number(faturamentoValorTotal);
    const postosNum = Number(postosTotal);
    if (!isNaN(faturamentoNum) && !isNaN(postosNum) && postosNum > 0) {
      ticketMedioPorPosto = faturamentoNum / postosNum;
    }
  }

  /**
   * Formas de Pagamento Mais Usadas
   */
  const formasPagamento = (resposta.visao_geral_formas_pg_usadas || []).map((item, index) => ({
    posicao: index + 1,
    formaPagamento: item['visao_geral.nome_forma_pagamento'] ?? item.nome_forma_pagamento ?? '-',
    valorTotal: item['visao_geral.valor_total'] ?? item.valor_total ?? 0,
    countLinhas: item['visao_geral.count_linhas'] ?? item.count_linhas ?? 0,
    abastecimentosPercentual: item['visao_geral.Abastecimentos_linhas_percentual'] ?? item.Abastecimentos_linhas_percentual ?? 0,
    faturamentoPercentual: item['visao_geral.Faturamento_linhas_percentual'] ?? item.Faturamento_linhas_percentual ?? 0,
  }));

  /**
   * Abastecimentos por Turno
   */
  const abastecimentosPorTurno = resposta.visao_geral_abastecimento_turno || [];
  
  // Calcular o total de abastecimentos para calcular percentuais
  const totalAbastecimentosTurno = abastecimentosPorTurno.reduce((acc, item) => {
    const count = item['visao_geral.count_linhas'] ?? item.count_linhas ?? 0;
    return acc + Number(count);
  }, 0);

  const turnosProcessados = abastecimentosPorTurno.map((item) => {
    const turno = item['visao_geral.turno'] ?? item.turno ?? '-';
    const countLinhas = item['visao_geral.count_linhas'] ?? item.count_linhas ?? 0;
    const percentual = totalAbastecimentosTurno > 0 
      ? (Number(countLinhas) / totalAbastecimentosTurno) * 100 
      : 0;
    
    return {
      turno,
      countLinhas: Number(countLinhas),
      percentual,
    };
  });

  // Ordenar por quantidade de abastecimentos (maior para menor)
  turnosProcessados.sort((a, b) => b.countLinhas - a.countLinhas);

  // Identificar os dois maiores turnos para exibir no centro do gráfico
  const turnosMaiores = turnosProcessados.slice(0, 2);
  const percentualTurnosMaiores = turnosMaiores.reduce((acc, item) => acc + item.percentual, 0);

  return {
    faturamento: {
      valorTotal: faturamentoValorTotal,
      percentualCrescimento: faturamentoPercentual,
      projecao: faturamentoProjecao,
    },
    lucro: {
      valorTotal: lucroValorTotal,
      percentualCrescimento: lucroPercentual,
      projecao: lucroProjecao,
      margem: margemLucro,
    },
    custo: {
      valorTotal: custoValorTotal,
      percentualCrescimento: custoPorcentagem,
      projecao: custoProjecao,
    },
    litros: {
      valorTotal: litrosValorTotal,
      projecao: litrosProjecao,
      volume: {
        produto: litrosVolumeProduto,
        percentual: litrosVolumePercentual,
      },
    },
    abastecimento: {
      valorTotal: abastecimentoValorTotal,
      percentualCrescimento: abastecimentoPercentual,
      projecao: abastecimentoProjecao,
      pico:{
        turno: picoAbastecimento,
        percentual: picoAbastecimentoPercentual,
      },
    },
    postos: {
      total: postosTotal,
      acimaMedia: postosAcimaMedia,
      mediaLucroPorPosto: mediaLucroPorPosto,
      ticketMedioPorPosto: ticketMedioPorPosto,
    },
    formasPagamento,
    abastecimentosTurno: {
      turnos: turnosProcessados,
      turnosMaiores,
      percentualTurnosMaiores,
      totalAbastecimentos: totalAbastecimentosTurno,
    },
  };
};

// TRATAMENTO PARA O GRAFICO DE COMPARATIVO ANUAL
const buscarDadosAnos = (obj) => {
  if (!obj || typeof obj !== 'object') return null;
  if (obj['visao_geral.data_hora_abastecimento_sp_year']) return obj['visao_geral.data_hora_abastecimento_sp_year'];
  for (const val of Object.values(obj)) {
    if (val && typeof val === 'object' && !Array.isArray(val)) {
      const chave = Object.keys(val)[0];
      if (chave && /^\d{4}$/.test(chave)) return val;
    }
  }
  return null;
};

export const processarComparativoAnual = (dadosAPI) => {
  if (!Array.isArray(dadosAPI) || dadosAPI.length === 0) return { labels: [], series: [], dadosPorMes: [], anos: [] };

  const dadosPorMesMap = new Map();
  const anosSet = new Set();
  const primeiroItem = dadosAPI[0];
  const temFiltroIndicador = primeiroItem && typeof primeiroItem['visao_geral.data_hora_abastecimento_sp_year'] === 'number' && typeof primeiroItem['visao_geral.indicador_selecionado'] === 'number';

  dadosAPI.forEach((item) => {
    const mesCompleto = item['visao_geral.mes_do_ano'] ?? item.mes_do_ano ?? item.mes_do_ano_completo;
    if (!mesCompleto) return;

    if (!dadosPorMesMap.has(mesCompleto)) {
      dadosPorMesMap.set(mesCompleto, { mesCompleto, mesAbreviado: obterMesAbreviado(mesCompleto) });
    }

    if (temFiltroIndicador) {
      const ano = item['visao_geral.data_hora_abastecimento_sp_year'];
      const valor = item['visao_geral.indicador_selecionado'];
      if (!ano) return;
      const anoStr = String(ano);
      if (!/^\d{4}$/.test(anoStr)) return;
      anosSet.add(anoStr);
      dadosPorMesMap.get(mesCompleto)[anoStr] = valor === null ? null : Number(valor);
    } else {
      const indicadorSelecionado = item['visao_geral.indicador_selecionado'] ?? item.indicador_selecionado ?? item['indicador_selecionado'] ?? {};
      const dadosAnos = buscarDadosAnos(indicadorSelecionado);
      if (!dadosAnos) return;
      Object.entries(dadosAnos).forEach(([ano, valor]) => {
        if (!/^\d{4}$/.test(ano)) return;
        anosSet.add(ano);
        dadosPorMesMap.get(mesCompleto)[ano] = valor === null ? null : Number(valor);
      });
    }
  });

  const dadosPorMes = Array.from(dadosPorMesMap.values()).sort((a, b) => MESES_ORDEM.indexOf(a.mesCompleto) - MESES_ORDEM.indexOf(b.mesCompleto));
  const labels = dadosPorMes.map(item => item.mesAbreviado);
  const anos = Array.from(anosSet).sort();
  const series = anos.map(ano => ({
    name: String(ano),
    ano: Number(ano),
    data: dadosPorMes.map(item => {
      const valor = item[ano];
      return valor === null ? null : (isNaN(valor) ? 0 : valor);
    }),
  }));

  return { labels, series, dadosPorMes, anos: anos.map(Number) };
};
